export const getOutsideOfContextHandler =
  (methodName: string) =>
  (...params: any): any =>
    console.error(`Tried to call ${methodName} outside of useMindmap context.`, params);
